import React from 'react';
import Loadable from 'react-loadable'
import DefaultLayout from './containers/DefaultLayout';
import LoadingScreen from 'react-loading-screen';
import logo from './assets/img/brand/LogoWeb.png';

function Loading(props) {
     return <LoadingScreen loading={true} spinnerColor='#9ee5f8' logoSrc={logo}><div></div></LoadingScreen>;
}

const Home = Loadable({
  loader: () => import('./views/Home/Home'),
  loading: Loading,
});

const ResumenCuenta = Loadable({
  loader: () => import('./views/CuentasCorrientes/'),
  loading: Loading,
});

const Empresa = Loadable({
  loader: () => import('./views/Empresa/Empresa'),
  loading: Loading,
});

const Novedades = Loadable({
  loader: () => import('./views/Novedades/Novedades'),
  loading: Loading,
});

const Contacto = Loadable({
  loader: () => import('./views/Contacto/Contacto'),
  loading: Loading,
});

const Productos = Loadable({
  loader: () => import('./views/Productos'),
  loading: Loading,
});

const Cart = Loadable({
  loader: () => import('./views/Cart'),
  loading: Loading,
});

const CompareList = Loadable ({
  loader: () => import('./views/Productos/CompareList.js'),
  loading: Loading,
})

const Perfil = Loadable({
  loader: () => import('./views/Perfil'),
  loading: Loading,
});

const Pedidos = Loadable({
  loader: () => import('./views/Pedidos'),
  loading: Loading,
});

const Payments = Loadable({
  loader: () => import('./views/Payments'),
  loading: Loading,
});

const PaymentsConfirmation = Loadable({
  loader: () => import('./views/Payments/ManagePayment.js'),
  loading: Loading,
});

const SpecificSearch = Loadable({
  loader: () => import('./views/Search'),
  loading: Loading,
});

const SearchResult = Loadable({
  loader: () => import('./views/SearchResult/SearchResult.js'),
  loading: Loading,
});

const routes = [
  { path: '/', exact: true, name: 'Home', component: Home },
  { path: '/empresa', exact: true, name: 'Empresa', component: Empresa },
  { path: '/novedades', exact: true, name: 'Novedades', component: Novedades },
  { path: '/contacto', exact: true, name: 'Contacto', component: Contacto },
  { path: '/productos', name: 'Productos', component: Productos },
  { path: '/ofertas', name: 'Ofertas', component: Productos },
  { path: '/producto', name: 'Productos', component: Productos },
  { path: '/cart', name: 'Cart', component: Cart, logged: true },
  { path: '/compareList', name: 'CompareList', component: CompareList, logged: true },
  { path: '/perfil', name: 'Perfil', component: Perfil, logged: true },
  { path: '/pedidos', name: 'Pedidos', component: Pedidos, logged: true },
  { path: '/payments', name: 'Pagos', component: Payments, logged: true },
  { path: '/resumencuenta', name: 'Resumen', component: ResumenCuenta, logged: true },
  { path: '/paymentStatus/:status', name: 'Pagos', component: PaymentsConfirmation },
  { path: '/Search', name: 'SpecificSearch', component: SpecificSearch },
  { path: '/ResultSearch/:text', name: 'SearchResult', component: SearchResult },
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js